export default __webpack_public_path__ + "static/media/57.95694b70.jpeg";